import type { FormField } from '@cli-types/core-engine/schema.js'
import { jsString } from '@cli-utils/text.js'

export function wrapShowWhen(field: FormField, jsx: string): string {
  if (!field.showWhen) return jsx
  const watchVar = `${field.showWhen.field}Value`
  const { value } = field.showWhen
  if (Array.isArray(value)) {
    const vals = value.map((v) => jsString(String(v))).join(', ')
    return `        {[${vals}].includes(${watchVar} as string) && (\n${jsx}\n        )}`
  }
  return `        {${watchVar} === ${jsString(String(value))} && (\n${jsx}\n        )}`
}
